import { emsApi } from '@/api/emsApi';
import type { Incident, LiveVideo } from '@/signalr';

export function recordingsQueryKey(incidentId: string): readonly unknown[] {
  return ['recordings', incidentId];
}

export function recordingDetailQueryKey(incidentId: string, videoId: string): readonly unknown[] {
  return ['recordings', incidentId, videoId];
}

export async function fetchIncidentLiveVideos(incidentId: string): Promise<LiveVideo[]> {
  const { data, response } = await emsApi.GET('/portal/v1/incident/{id}', {
    params: { path: { id: incidentId } },
  });

  if (data === undefined) {
    throw new Error(`Failed to load incident ${incidentId} (HTTP ${response.status})`);
  }

  return (data as unknown as Incident).caller.liveVideos;
}

export async function fetchRecording(incidentId: string, videoId: string): Promise<LiveVideo | null> {
  const liveVideos = await fetchIncidentLiveVideos(incidentId);
  return liveVideos.find((liveVideo) => liveVideo.id.toLowerCase() === videoId.toLowerCase()) ?? null;
}
